<template>
    <div class="collection-item-box" @click="$modal.open('order', {cart})">
      <h2 class="truncate" v-text="cart.customer.name"></h2>
      <hr>
      <div class="flex justify-between">
        <vue-tag icon="cupcake-solid">{{ cart.products.length }}</vue-tag>
        <vue-tag :class="statusClass" icon="hourglass-solid">{{ isExpired ? 'Expiré' : expiredAt }}</vue-tag>
      </div>
      <hr>
      <div class="flex justify-center">
        <confirm-button @confirmed="handleDestroyClick"
                        popover-type="popover-top"
                        btn-icon="close"
                        btn-class="btn-primary btn-outline btn-sm mt-2"
                        btn-confirm-text="Supprimer"
                        :status="status">Supprimer</confirm-button>
      </div>
    </div>
</template>

<script>
/* globals moment axios route */
import ErrorHandler from '../../core/ErrorHandler';
import ConfirmButton from '../ConfirmButton.vue';

export default {
  components: { ConfirmButton },

  props: {
    cart: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isExpired() {
      return this.cart.status === 'expired';
    },

    expiredAt() {
      return moment(this.cart.expired_at).fromNow(true);
    },

    statusClass() {
      if (this.cart.status === 'expired') {
        return 'bg-red-lightest text-red-light';
      }

      if (this.cart.status === 'expiring-soon') {
        return 'bg-orange-lightest text-orange-light';
      }

      return 'bg-green-lightest text-green-light';
    },
  },

  data() {
    return {
      status: null,
    };
  },

  methods: {
    handleDestroyClick() {
      this.status = 'loading';
      axios
        .delete(route('api.carts.destroy', this.cart.id))
        .then(() => this.onSuccess())
        .catch(error => this.onFail(error));
    },

    onSuccess() {
      this.status = 'succeeded';
      this.$notify({
        type: 'success',
        title: 'Succès',
        text: 'Supprimé avec succès.',
      });
      setTimeout(() => {
        this.status = null;
        Event.fire('cartDeleted', this.cart);
      }, 1500);
    },

    onFail(error) {
      this.status = 'failed';
      new ErrorHandler(error).dispatch();
      setTimeout(() => {
        this.status = null;
      }, 1500);
    },
  },
};
</script>